import StorageAnsiraProfileForm from 'src/cms-components/StorageAnsiraProfileForm/StorageAnsiraProfileForm';
import StorageAppLinkBundle from 'src/cms-components/StorageAppLinkBundle/StorageAppLinkBundle';
import StorageArticleCards from 'src/cms-components/StorageArticleCards/StorageArticleCards';
import StorageBanner from 'src/cms-components/StorageBanner/StorageBanner';
import StorageBrandGrid from 'src/cms-components/StorageBrandGrid/StorageBrandGrid';
import StorageCardGrid from 'src/cms-components/StorageCardGrid/StorageCardGrid';
import StorageCategoryCards from 'src/cms-components/StorageCategoryCards/StorageCategoryCards';
import StorageFaqSection from 'src/cms-components/StorageFaqSection/StorageFaqSection';
import StorageHeroCard from 'src/cms-components/StorageHeroCard/HeroCardHelper';
import StorageHighlights from 'src/cms-components/StorageHighlights/StorageHighlights';
import StorageHotspots from 'src/cms-components/StorageHotspots/StorageHotspots';
import StorageImageContent from 'src/cms-components/StorageImageContent/StorageImageContent';
import StorageIngredientsMap from 'src/cms-components/StorageIngredientsMap/StorageIngredientsMap';
import StorageJavascriptFeature from 'src/cms-components/StorageJavascriptFeature/StorageJavascriptFeature';
import StoragePageTitle from 'src/cms-components/StoragePageTitle/StoragePageTitle';
import StorageProductCards from 'src/cms-components/StorageProductCards/StorageProductCards';
import StorageReviews from 'src/cms-components/StorageReviews/StorageReviews';
import StorageRichText from 'src/cms-components/StorageRichText/StorageRichText';
import StorageSmartAppBanner from 'src/cms-components/StorageSmartAppBanner/StorageSmartAppBanner';
import StorageSubnav from 'src/cms-components/StorageSubnav/StorageSubnav';
import StorageSubnavMenu from 'src/cms-components/StorageSubnavMenu/StorageSubnavMenu';
import StorageUnfilteredHtml from 'src/cms-components/StorageUnfilteredHtml/StorageUnfilteredHtml';
import StorageVideo from 'src/cms-components/StorageVideo/StorageVideo';

const cmsComponentRegistry = {
  storage__app_link_bundle: StorageAppLinkBundle,
  storage__article_cards: StorageArticleCards,
  storage__image_content: StorageImageContent,
  storage__hero_card: StorageHeroCard,
  storage__hotspots: StorageHotspots,
  storage__product_cards: StorageProductCards,
  storage__highlights: StorageHighlights,
  storage__rich_text: StorageRichText,
  storage__ansira_profile_form: StorageAnsiraProfileForm,
  storage__ingredients_map: StorageIngredientsMap,
  storage__page_title: StoragePageTitle,
  storage__banner: StorageBanner,
  storage__brand_grid: StorageBrandGrid,
  storage__faq_section: StorageFaqSection,
  storage__html: StorageUnfilteredHtml,
  storage__smart_app_banner: StorageSmartAppBanner,
  storage__subnav: StorageSubnav,
  storage__subnav_menu: StorageSubnavMenu,
  storage__card_grid: StorageCardGrid,
  storage__reviews: StorageReviews,
  storage__category_cards: StorageCategoryCards,
  storage__video: StorageVideo,
  storage__javascript_feature: StorageJavascriptFeature,
} as const;

export type CmsComponentType = keyof typeof cmsComponentRegistry;
export type CmsComponentPropsMap = {
  [K in CmsComponentType]: React.ComponentProps<(typeof cmsComponentRegistry)[K]>;
};
export default cmsComponentRegistry;
